import React from 'react';
import Component from 'components/component';
import { DI } from 'modules';

import HeaderLangItem from './header-lang-item';

export class HeaderLang extends Component {
    render() {
        return (
            <div className="header-lang">
                <div className="iwrap">
                    <ul className="header-lang-list">
                        {this.props.locales.list.payload.map((locale) => {
                            return (
                                <HeaderLangItem
                                    key={locale.code}
                                    locale={locale}
                                />
                            );
                        })}
                    </ul>
                </div>
            </div>
        );
    }
}

export default DI(['locales', 'common'])(HeaderLang);
